export default __webpack_public_path__ + "static/media/logo.e507e4df.svg";